module.exports = __webpack_public_path__ + "static/media/video.4401f188.jpg";